/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CatalogLoadResponse
 */
export interface CatalogLoadResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CatalogLoadResponse
     */
    success?: boolean;
}

/**
 * Check if a given object implements the CatalogLoadResponse interface.
 */
export function instanceOfCatalogLoadResponse(value: object): value is CatalogLoadResponse {
    return true;
}

export function CatalogLoadResponseFromJSON(json: any): CatalogLoadResponse {
    return CatalogLoadResponseFromJSONTyped(json, false);
}

export function CatalogLoadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CatalogLoadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
    };
}

export function CatalogLoadResponseToJSON(json: any): CatalogLoadResponse {
    return CatalogLoadResponseToJSONTyped(json, false);
}

export function CatalogLoadResponseToJSONTyped(value?: CatalogLoadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
    };
}

